import React, { useState, useEffect } from "react";
import backicon from './../../../../../../Assets/icons/backIcon.svg';
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API"; 
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import { toastError, toastSuccess } from "../../../../../customComponents/customToast/Toast";
import { ToastContainer } from "react-toastify";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import Swal from "sweetalert2";


const EditPublisher = () => {
  const [formData, setFormData] = useState({});
  const [sourceOptions, setSourceOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [  publisher, setPublisher ] = useState([])
  const navigate = useNavigate();
  const location = useLocation();
  const Token = localStorage.getItem("authToken");
  const { data } = location.state || {};
  const [ userTypedd, setUserTypedd ] = useState([])
  const userType = localStorage.getItem("UserType")
  console.log(userType, "usertype")
  const businessPartnerId =data?.business_partner_id

  useEffect(() => {
    fetchSourceOptions()
  },[formData?.business_partner_id])

  const fetchSourceOptions = async () => {
    try {
      const authToken = localStorage.getItem("authToken"); 
      const business_partner_id = userType==="superadmin"?formData?.business_partner_id: businessPartnerId; 
      const response = await axiosInstance.post('/source/list', {
        business_partner_id,
        orderBy: 'source_id desc',
        page: 0,
        pageSize: 100,
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
      });

      const options = response.data.data.data.map(source => ({
        label: source.source_name,
        value: source.source_id,
      }));

      setSourceOptions(options);
    } catch (error) {
      console.error('Error fetching source options:', error);
    }
  };

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;
  
    // Validate required fields
    PublisherInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      }
    });
  
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
  
    setLoading(true); 
    const result = await Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to update this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const authToken = localStorage.getItem("authToken");
          const payload = {
            source_id: formData.source_name,
            publisher_name: formData.publisher_name,
            publisher_desc: formData.publisher_desc,
            status: formData.status === "Active" ? 1 : 0,
          };
  
          // Add business partner ID based on user type
          if (userType === "superadmin") {
            payload.business_partner_id = formData.business_partner_id;
          } else {
            payload.business_partner_id = businessPartnerId;
          }
  
          // Make API call to update the publisher
          const response = await axiosInstance.patch(`/publisher/update/${data.publisher_id}`, payload, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          });
  
          // Handle successful response
          if (response.status === 200) {
            Swal.fire({
              title: "Success",
              text: "Publisher updated successfully!",
              icon: "success",
              confirmButtonText: "OK",
            }).then(() => {
              navigate(ROUTES_NAVIGATION.PUBLISHERLIST); // Navigate after user clicks OK
            });
          }
        } catch (error) {
          console.error('Error updating publisher:', error);
  
          const errorMessage = error.response?.data?.message || "An error occurred while processing your request.";
          Swal.fire({
            title: "Something went wrong",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setLoading(false); // Stop loading
        }
      },
    });
  
    // Stop loading if user cancels
    if (!result.isConfirmed) {
      setLoading(false);
    }
  };
  

  const fetchPublisherEdit = async () => {
    try{
      const response = await axiosInstance.get(`/publisher/edit/${data.publisher_id}`,{
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
        },
    })
    const fetchedData = response.data.data
    const formatedData = {
      source_name:fetchedData.source_id,
      publisher_name:fetchedData.publisher_name,
      publisher_desc:fetchedData.publisher_desc,
      business_partner_id:fetchedData.business_partner_id,
      status: fetchedData.status === 1 ? "Active" : "Inactive",
    }
    setFormData(formatedData)
    setPublisher(fetchedData)
    console.log(formData, "HSNCODE DATA")
  
  }catch(error){
      console.log(error)
    }
  
  }
  
  useEffect(() => {
    fetchPublisherEdit()
  },[])

  useEffect(() => {
    if (userType === "superadmin") {
      userTypedropdown();
    }
  }, [userType]);

  // useEffect(() => {
  //   userTypedropdown();
  // },[])
  
  const userTypedropdown = async () => {
    console.log("hello")
    try{
      const response = await axiosInstance.get("/bp-onboard/bplist",{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
      })
  
      const data = response.data.data.data
      const userTypeOptions = data.map(user => ({
        value: user.onboard_id,
        label:user.bp_name,
      }))
      setUserTypedd(userTypeOptions)
    }catch(error) {
      console.log(error)
    }
  }

  const PublisherInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
            validation: {
              required: true,
              pattern: /^[A-Za-z0-9 ]*$/,
              message: "Only alphabets and digits are allowed",
            },
          },
        ]
      : []),
    {
      name: "source_name",
      label: "Source Name",
      type: "dropdown",
      required: true,
      options: [], 
      gridClass: "col-lg-4",
      validation: { required: true,
      
       },
    },
    {
      name: "publisher_name",
      label: "Publisher Name",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true,
        pattern: /^[A-Za-z0-9-\s]*$/,
        message: "Special symbols are not allowed",
     },
    },
    {
      name: "publisher_desc",
      label: "Description",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { label: "Active", value: "Active" },
        { label: "Inactive", value: "Inactive" },
      ],
      validation: {
        required: true,
        message: "Status is required",
      },
      gridClass: "col-lg-4",
    },
  ];

  return (
    <>
    <ToastContainer />
      <div className="backbutton mt-2 mb-2" onClick={() => navigate(ROUTES_NAVIGATION.PUBLISHERLIST)}>
        <img src={backicon} alt="back" />
        <span className="backbtntitle">Edit Publisher</span>
      </div>
      <div className="form-container">
        <span className="cust-det-title mt-2 mb-2">
          Please Enter Publisher Details
        </span>
        <DynamicForm
          formConfig={PublisherInputs.map(input => input.name === 'source_name' ? { ...input, options: sourceOptions } : input)}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
      </div>
      <div className="btncontainer mt-3">
        <button
          onClick={() => handleFormSubmit(formData)}
          className="submit-btn"
        >
          Submit
        </button>
      </div>
    </>
  );
};

export default EditPublisher;
